import { render, staticRenderFns } from "./expend_list.vue?vue&type=template&id=2df4472c"
import script from "./expend_list.vue?vue&type=script&lang=js"
export * from "./expend_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports